import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-account-dialog',
  templateUrl: './customer-account-dialog.component.html',
  styleUrls: ['./customer-account-dialog.component.scss']
})
export class CustomerAccountDialogComponent implements OnInit {
  @Input() additionalClass: any;

  constructor() { }

  ngOnInit(): void {
    /* istanbul ignore next */
    (function smoothscroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
      window.scrollTo(0, 0);
      }
    })();
   
  }

}
